const WELLNESS_AXIS_PAD = 5;
const WELLNESS_AXIS_MIN = 0;
const WELLNESS_AXIS_MAX = 100;

export function wellnessYDomain(values: number[]): [number, number] {
  if (values.length === 0) {
    return [WELLNESS_AXIS_MIN, WELLNESS_AXIS_MAX];
  }

  const lo = Math.min(...values);
  const hi = Math.max(...values);

  return [
    Math.max(WELLNESS_AXIS_MIN, lo - WELLNESS_AXIS_PAD),
    Math.min(WELLNESS_AXIS_MAX, hi + WELLNESS_AXIS_PAD),
  ];
}

export function wellnessYTicks(domain: [number, number]): number[] {
  const lo = domain[0];
  const hi = domain[1];
  const span = hi - lo;
  if (span <= 0) {
    return [lo];
  }

  const step = span <= 20 ? 5 : span <= 50 ? 10 : 20;
  const ticks: number[] = [];
  const first = Math.ceil(lo / step) * step;
  for (let value = first; value <= hi; value += step) {
    ticks.push(value);
  }

  return ticks.length > 0 ? ticks : [lo, hi];
}
